import { LitElement, html, svg } from 'lit';

export class IconFilter16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>To horisontale skyveknapper over hverandre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1 3h8M7 13h8M13 3h2M1 13h2"></path><circle cx="11" cy="3" r="2" stroke="currentColor" stroke-width="1.5"></circle><circle cx="5" cy="13" r="2" stroke="currentColor" stroke-width="1.5"></circle></svg>`; }
}
if (!customElements.get('f-icon-filter16', IconFilter16)) {
  customElements.define('f-icon-filter16', IconFilter16);
}